import { render, staticRenderFns } from "./tabGatheringTrailerBaseUICustom.vue?vue&type=template&id=4e38c991&scoped=true&"
import script from "./tabGatheringTrailerBaseUICustom.vue?vue&type=script&lang=js&"
export * from "./tabGatheringTrailerBaseUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabGatheringTrailerBaseUICustom.vue?vue&type=style&index=0&id=4e38c991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38c991",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e38c991')) {
      api.createRecord('4e38c991', component.options)
    } else {
      api.reload('4e38c991', component.options)
    }
    module.hot.accept("./tabGatheringTrailerBaseUICustom.vue?vue&type=template&id=4e38c991&scoped=true&", function () {
      api.rerender('4e38c991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBaseUICustom.vue"
export default component.exports